import React from 'react';
import { View } from 'react-native';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import FrameworkTestKeys from '../../../FrameworkTestKeys';
import styles from '../styles';

function CustomTabs({ onPress, selectedTab, children, containerStyle }) {
  const theme = useTheme();
  return (
    <View
      style={[styles.containerStyle, containerStyle]}
      testID={FrameworkTestKeys.customTabsContainer}
    >
      {children.map((child, index) =>
        React.cloneElement(child, {
          isFirstTab: index === 0,
          isLastTab: index === children.length - 1,
          isActiveTab: selectedTab === child.props.value,
          handelOnPress: () => onPress(child.props.value),
          theme: theme,
        }),
      )}
    </View>
  );
}

CustomTabs.defaultProps = {
  onPress: () => {},
  selectedTab: 0,
  children: [<></>],
};

CustomTabs.propTypes = {
  onPress: PropTypes.func.isRequired,
  selectedTab: PropTypes.number.isRequired,
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
  containerStyle: ViewPropTypes.style,
};

export default CustomTabs;
